import React, { useEffect } from 'react';
import classnames from 'classnames';
import { usePrefersReducedMotion } from '@jokerdad/hooks';
import { useMainContext } from '@jokerdad/providers';
import styles from './Searchbar.module.scss';
import { enterAnimation, enterWithoutAnimation } from './utils';

var Searchbar = function Searchbar(_ref) {
  var onSubmit = _ref.onSubmit,
      onChange = _ref.onChange;
  var formClasses = classnames(styles.form, 'js-anime-search-form');
  var effectClasses = classnames(styles.effect, 'js-anime-wave-effect');
  var isReducedMotionPreferred = usePrefersReducedMotion();

  var _useMainContext = useMainContext(),
      visitingViaUrl = _useMainContext[0].visitingViaUrl;

  useEffect(function () {
    if (isReducedMotionPreferred || visitingViaUrl) {
      return enterWithoutAnimation();
    }

    enterAnimation();
  }, [isReducedMotionPreferred, visitingViaUrl]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.scene
  }, /*#__PURE__*/React.createElement("div", {
    className: effectClasses
  }), /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit,
    className: formClasses
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    onChange: onChange,
    placeholder: "Search...",
    className: styles.input
  })));
};

export default Searchbar;